module.exports = __webpack_public_path__ + "img/tournament-circle_nav.989fef1f.svg";